export default function Footer() {
  return (
    <footer className="bg-[#F5C518]">
      <div className="max-w-6xl mx-auto px-8 py-16">
        <div className="flex flex-col md:flex-row justify-between gap-12">
          {/* Brand */}
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-black rounded-md flex items-center justify-center">
                <span className="text-[#F5C518] font-black text-sm tracking-tight">RD</span>
              </div>
              <div className="leading-none">
                <span className="block font-black text-sm tracking-widest uppercase text-black">REGENT</span>
                <span className="block font-black text-sm tracking-widest uppercase text-black/60">DIGITAL</span>
              </div>
            </div>
            <p className="text-black/70 text-sm leading-relaxed max-w-xs">
              Technology and marketing — united into one growth strategy.
            </p>
          </div>

          {/* Address */}
          <div className="flex-1">
            <h4 className="font-black text-xs tracking-widest uppercase text-black mb-4">Business Address</h4>
            <address className="not-italic text-black/80 text-sm leading-relaxed space-y-1">
              <p className="font-bold text-black">Regent Digital LTD</p>
              <p>International House</p>
              <p>55 Longsmith Street</p>
              <p>Gloucester</p>
              <p>GL1 2HT</p>
              <p>United Kingdom</p>
            </address>
          </div>

          {/* Contact */}
          <div className="flex-1">
            <h4 className="font-black text-xs tracking-widest uppercase text-black mb-4">Contact</h4>
            <div className="space-y-3">
              <a
                href="tel:+447520657571"
                className="flex items-center gap-3 text-black/80 hover:text-black transition-colors text-sm cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-base"></i>
                </div>
                +447520657571
              </a>
              <a
                href="mailto:support@regent-digital.com"
                className="flex items-center gap-3 text-black/80 hover:text-black transition-colors text-sm cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-base"></i>
                </div>
                support@regent-digital.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t-2 border-black/20 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-black/60 text-xs tracking-wide">
            &copy; {new Date().getFullYear()} Regent Digital LTD. All rights reserved.
          </p>
          <p className="text-black/60 text-xs tracking-wide">
            Registered in England &amp; Wales
          </p>
        </div>
      </div>
    </footer>
  );
}
